



































































































import { Component, Vue } from "vue-property-decorator";
import FaqQuestion from "@/components/FaqQuestion.vue";
import { ButtonVariant } from "@/types";
import { createPartyPage } from "@/router";

@Component({
  components: { FaqQuestion },
})
export default class FaqPage extends Vue {
  $enums = {
    ButtonVariant,
  };

  onClick(): void {
    this.$router.push(createPartyPage());
  }
}
